export default __webpack_public_path__ + "static/media/waitingAreas.499a5187.jpg";